var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutorizationSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 318,
    height: 300,
    viewBox: "0 0 318 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3375_12697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.443 2.409C92.3488 5.97948 68.2287 13.8214 47.9613 27.684C18.3056 47.9931 1.85406 78.3127 0.141741 111.299C-0.994886 133.075 4.86539 154.308 11.9509 174.984C21.0513 201.582 26.9263 231.882 45.9021 254.615C75.4913 289.993 132.692 304.917 180.526 298.581C211.429 294.493 244.081 278.927 253.595 250.757C257.115 240.334 258.835 229.137 264.85 219.5C272.054 207.957 285.133 201.216 295.06 191.814C307.319 180.205 312.264 165.74 315.32 150.436C322.398 114.954 311.939 75.9477 287.531 47.148C260.872 15.7016 217.599 4.20407 175.293 0.921851C156.317 -0.584954 136.603 -0.349106 117.443 2.409Z",
    fill: "#1AE5B2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M117.443 2.409C92.3488 5.97948 68.2287 13.8214 47.9613 27.684C18.3056 47.9931 1.85406 78.3127 0.141741 111.299C-0.994886 133.075 4.86539 154.308 11.9509 174.984C21.0513 201.582 26.9263 231.882 45.9021 254.615C75.4913 289.993 132.692 304.917 180.526 298.581C211.429 294.493 244.081 278.927 253.595 250.757C257.115 240.334 258.835 229.137 264.85 219.5C272.054 207.957 285.133 201.216 295.06 191.814C307.319 180.205 312.264 165.74 315.32 150.436C322.398 114.954 311.939 75.9477 287.531 47.148C260.872 15.7016 217.599 4.20407 175.293 0.921851C156.317 -0.584954 136.603 -0.349106 117.443 2.409Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.863 241.496C216.21 241.496 263.51 194.196 263.51 135.848C263.51 77.5011 216.21 30.2012 157.863 30.2012C99.5157 30.2012 52.2158 77.5011 52.2158 135.848C52.2158 194.196 99.5157 241.496 157.863 241.496Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeDasharray: "3.01 3.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.531 97.9593C244.531 97.9593 208.714 93.2888 160.058 43.2159V42.5249L159.717 42.866L159.385 42.5249V43.2159C110.764 93.2888 74.9388 97.9593 74.9388 97.9593C62.1779 202.846 150.813 238.776 159.402 242.029V242.274L159.735 242.152L160.076 242.274V242.029C168.665 238.776 257.3 202.802 244.531 97.9593Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.901 101.379C237.901 101.379 204.901 97.0845 160.058 50.93V50.2915L159.743 50.6151L159.437 50.2915V50.93C114.586 97.1107 81.5948 101.379 81.5948 101.379C69.8222 198.096 151.566 231.254 159.437 234.236V234.464L159.743 234.35L160.058 234.464V234.236C167.974 231.254 249.7 198.096 237.901 101.379Z",
    fill: "#1AE5B2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M221.755 109.863C221.755 109.863 195.516 106.478 159.98 69.8482V69.3496C159.901 69.4283 159.822 69.5158 159.735 69.5945L159.49 69.3496V69.8482C123.918 106.478 97.7231 109.863 97.7231 109.863C88.382 186.568 153.21 212.869 159.49 215.23V215.414L159.735 215.318L159.98 215.414V215.23C166.268 212.869 231.088 186.568 221.755 109.863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9359 70.2243C106.838 70.2243 114.866 62.1968 114.866 52.2943C114.866 42.3918 106.838 34.3643 96.9359 34.3643C87.0334 34.3643 79.0059 42.3918 79.0059 52.2943C79.0059 62.1968 87.0334 70.2243 96.9359 70.2243Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6328 47.5975H94.1196V42.6296C94.1219 42.0318 94.3604 41.4592 94.7831 41.0365C95.2058 40.6138 95.7784 40.3754 96.3762 40.373V40.373C96.6725 40.373 96.966 40.4314 97.2397 40.5448C97.5135 40.6582 97.7623 40.8244 97.9718 41.034C98.1814 41.2435 98.3476 41.4923 98.461 41.7661C98.5744 42.0398 98.6328 42.3333 98.6328 42.6296V47.5975Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7026 43.9768C95.6294 43.9762 95.5575 43.9582 95.4927 43.9244L91.6618 41.8865C91.5898 41.8515 91.5294 41.7967 91.4875 41.7285C91.4457 41.6603 91.4242 41.5816 91.4256 41.5016V38.5716C91.4256 38.4556 91.4717 38.3444 91.5537 38.2624C91.6357 38.1804 91.7469 38.1343 91.8629 38.1343C91.9789 38.1343 92.0901 38.1804 92.1722 38.2624C92.2542 38.3444 92.3002 38.4556 92.3002 38.5716V41.2392L95.9037 43.1459C96.0197 43.1726 96.1203 43.2443 96.1835 43.3451C96.2466 43.446 96.2671 43.5679 96.2405 43.6838C96.2138 43.7998 96.1421 43.9005 96.0413 43.9636C95.9404 44.0268 95.8186 44.0473 95.7026 44.0206V43.9768Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0845 43.9768C96.9685 44.0047 96.8462 43.9853 96.7445 43.923C96.6428 43.8606 96.57 43.7605 96.5422 43.6445C96.5144 43.5285 96.5337 43.4062 96.5961 43.3045C96.6584 43.2028 96.7586 43.13 96.8746 43.1022L100.478 41.1955V38.5716C100.478 38.4556 100.524 38.3444 100.606 38.2624C100.688 38.1804 100.799 38.1343 100.915 38.1343C101.031 38.1343 101.143 38.1804 101.225 38.2624C101.307 38.3444 101.353 38.4556 101.353 38.5716V41.5016C101.354 41.5805 101.333 41.6581 101.293 41.726C101.253 41.7939 101.195 41.8495 101.125 41.8865L97.2856 43.9244C97.2243 43.9592 97.155 43.9773 97.0845 43.9768V43.9768Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6036 63.3937C101.84 63.3937 106.085 59.1489 106.085 53.9127C106.085 48.6764 101.84 44.4316 96.6036 44.4316C91.3674 44.4316 87.1226 48.6764 87.1226 53.9127C87.1226 59.1489 91.3674 63.3937 96.6036 63.3937Z",
    fill: "#1AE5B2",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.134 51.6472C80.0158 51.6469 79.9026 51.5997 79.8192 51.516C79.7385 51.4328 79.6934 51.3214 79.6934 51.2055C79.6934 51.0896 79.7385 50.9782 79.8192 50.895L83.204 47.5102C83.2611 47.4555 83.3316 47.417 83.4085 47.3985C83.4853 47.3801 83.5657 47.3824 83.6413 47.4052L88.2594 48.7609C88.3168 48.777 88.3705 48.8042 88.4174 48.8411C88.4643 48.8779 88.5035 48.9236 88.5328 48.9756C88.562 49.0276 88.5807 49.0848 88.5878 49.144C88.595 49.2032 88.5903 49.2632 88.5743 49.3207C88.5582 49.3781 88.5309 49.4318 88.4941 49.4787C88.4573 49.5256 88.4116 49.5648 88.3596 49.594C88.3076 49.6233 88.2504 49.642 88.1912 49.6491C88.132 49.6562 88.0719 49.6516 88.0145 49.6355L83.6413 48.3498L80.4664 51.516C80.4234 51.56 80.3715 51.5945 80.3142 51.6171C80.2569 51.6397 80.1955 51.65 80.134 51.6472Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8077 57.2885C80.7249 57.2878 80.644 57.2636 80.5744 57.2188C80.5048 57.1739 80.4494 57.1102 80.4146 57.0351C80.3797 56.96 80.367 56.8765 80.3777 56.7944C80.3885 56.7123 80.4223 56.6349 80.4753 56.5713L82.9593 53.6325C82.9995 53.5833 83.0502 53.5436 83.1077 53.5164C83.1652 53.4891 83.228 53.475 83.2917 53.4751H87.1226C87.2385 53.4751 87.3498 53.5212 87.4318 53.6032C87.5138 53.6852 87.5599 53.7964 87.5599 53.9124C87.5599 54.0284 87.5138 54.1396 87.4318 54.2216C87.3498 54.3037 87.2385 54.3497 87.1226 54.3497H83.4928L81.1401 57.1311C81.0998 57.1803 81.0491 57.22 80.9916 57.2473C80.9341 57.2745 80.8713 57.2886 80.8077 57.2885V57.2885Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5189 63.6034H83.4576C83.3439 63.586 83.2412 63.5254 83.1711 63.4341C83.101 63.3428 83.0689 63.228 83.0815 63.1136L83.5363 59.5014C83.5432 59.4411 83.5622 59.3829 83.5923 59.3303C83.6224 59.2777 83.6629 59.2317 83.7113 59.1952L87.2623 56.7025C87.358 56.637 87.4754 56.6113 87.5897 56.6309C87.704 56.6505 87.8061 56.7138 87.8745 56.8075C87.9081 56.8545 87.932 56.9077 87.9449 56.964C87.9578 57.0203 87.9594 57.0786 87.9497 57.1355C87.9399 57.1924 87.919 57.2468 87.888 57.2956C87.8571 57.3444 87.8169 57.3866 87.7696 57.4197L84.376 59.8075L83.9474 63.2186C83.9347 63.3237 83.8843 63.4207 83.8054 63.4915C83.7266 63.5623 83.6248 63.6021 83.5189 63.6034Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.082 51.6474C112.964 51.6471 112.85 51.5999 112.767 51.5162L109.566 48.3151L105.193 49.6445C105.135 49.6612 105.075 49.6663 105.016 49.6597C104.956 49.6532 104.899 49.6349 104.846 49.6061C104.794 49.5773 104.748 49.5384 104.71 49.4917C104.673 49.445 104.645 49.3914 104.628 49.334C104.612 49.2766 104.607 49.2164 104.613 49.157C104.62 49.0976 104.638 49.04 104.667 48.9876C104.696 48.9352 104.734 48.889 104.781 48.8517C104.828 48.8143 104.881 48.7865 104.939 48.7699L109.574 47.3705C109.65 47.3457 109.731 47.3424 109.808 47.361C109.885 47.3795 109.956 47.4191 110.012 47.4754L113.397 50.8602C113.477 50.9435 113.522 51.0548 113.522 51.1707C113.522 51.2866 113.477 51.398 113.397 51.4812C113.359 51.5295 113.311 51.5692 113.257 51.5978C113.203 51.6264 113.143 51.6433 113.082 51.6474Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.399 57.2885C112.336 57.2886 112.273 57.2745 112.215 57.2473C112.158 57.22 112.107 57.1803 112.067 57.1311L109.714 54.3497H106.085C105.969 54.3497 105.857 54.3037 105.775 54.2216C105.693 54.1396 105.647 54.0284 105.647 53.9124C105.647 53.7964 105.693 53.6852 105.775 53.6032C105.857 53.5212 105.969 53.4751 106.085 53.4751H109.915C109.98 53.4761 110.044 53.4906 110.103 53.5177C110.161 53.5448 110.214 53.5839 110.257 53.6325L112.732 56.5713C112.769 56.6146 112.798 56.665 112.815 56.7195C112.833 56.774 112.84 56.8314 112.835 56.8885C112.83 56.9456 112.814 57.0011 112.787 57.0518C112.76 57.1025 112.724 57.1473 112.679 57.1836C112.602 57.2524 112.503 57.2899 112.399 57.2885V57.2885Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.688 63.6035C109.582 63.6021 109.48 63.5624 109.401 63.4916C109.323 63.4208 109.272 63.3238 109.259 63.2187L108.831 59.7988L105.463 57.3761C105.411 57.3452 105.366 57.3038 105.331 57.2545C105.296 57.2052 105.271 57.1492 105.258 57.0898C105.246 57.0305 105.246 56.9692 105.258 56.9099C105.271 56.8506 105.295 56.7945 105.331 56.7452C105.366 56.6959 105.411 56.6545 105.463 56.6236C105.516 56.5927 105.574 56.573 105.634 56.5657C105.694 56.5584 105.755 56.5637 105.813 56.5812C105.871 56.5988 105.925 56.6282 105.971 56.6676L109.469 59.2041C109.518 59.2387 109.56 59.2829 109.591 59.334C109.623 59.3851 109.644 59.4421 109.653 59.5015L110.099 63.1137C110.114 63.2285 110.083 63.3445 110.012 63.4363C109.942 63.5281 109.838 63.5883 109.723 63.6035H109.688Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0409 63.3934H96.1663V50.4488L99.0526 48.3672L99.5686 49.0756L97.0409 50.9036V63.3934Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0233 57.4635L96.6384 56.685L101.353 54.3235V50.0815H102.227V54.8658L97.0233 57.4635Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3761 54.2884L92.554 51.9006V48.0522H93.4286V51.4196L96.8397 53.545L96.3761 54.2884Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3673 60.8311L91.1982 57.5425V54.1401H92.0729V57.0614L96.8396 60.0877L96.3673 60.8311Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.93 48.9796C93.4227 48.9796 93.8221 48.5802 93.8221 48.0874C93.8221 47.5947 93.4227 47.1953 92.93 47.1953C92.4373 47.1953 92.0378 47.5947 92.0378 48.0874C92.0378 48.5802 92.4373 48.9796 92.93 48.9796Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.481 49.5567C99.9737 49.5567 100.373 49.1573 100.373 48.6646C100.373 48.1719 99.9737 47.7725 99.481 47.7725C98.9883 47.7725 98.5889 48.1719 98.5889 48.6646C98.5889 49.1573 98.9883 49.5567 99.481 49.5567Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.604 49.9943C102.604 50.1673 102.552 50.3363 102.456 50.4802C102.36 50.624 102.223 50.7361 102.064 50.8023C101.904 50.8685 101.728 50.8858 101.558 50.8521C101.389 50.8183 101.233 50.735 101.11 50.6127C100.988 50.4904 100.905 50.3346 100.871 50.1649C100.837 49.9952 100.855 49.8194 100.921 49.6595C100.987 49.4997 101.099 49.3631 101.243 49.267C101.387 49.1709 101.556 49.1196 101.729 49.1196C101.961 49.1196 102.183 49.2118 102.347 49.3758C102.511 49.5398 102.604 49.7623 102.604 49.9943Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5364 54.0177C92.5364 54.1907 92.4851 54.3598 92.389 54.5036C92.2929 54.6475 92.1563 54.7596 91.9965 54.8258C91.8366 54.892 91.6608 54.9093 91.4911 54.8755C91.3214 54.8418 91.1656 54.7585 91.0433 54.6362C90.921 54.5138 90.8377 54.358 90.8039 54.1883C90.7702 54.0187 90.7875 53.8428 90.8537 53.683C90.9199 53.5232 91.032 53.3866 91.1758 53.2905C91.3197 53.1944 91.4888 53.1431 91.6618 53.1431C91.8937 53.1431 92.1162 53.2352 92.2802 53.3992C92.4442 53.5633 92.5364 53.7857 92.5364 54.0177Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.333 41.4474C118.672 37.9929 116.957 34.1069 113.503 32.7676C110.048 31.4284 106.162 33.1432 104.823 36.5977C103.484 40.0521 105.199 43.9382 108.653 45.2774C112.108 46.6166 115.994 44.9018 117.333 41.4474Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.12 43.111L116.038 34.9419",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.175 70.2243C232.077 70.2243 240.105 62.1968 240.105 52.2943C240.105 42.3918 232.077 34.3643 222.175 34.3643C212.272 34.3643 204.245 42.3918 204.245 52.2943C204.245 62.1968 212.272 70.2243 222.175 70.2243Z",
    fill: "#1AE5B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.163 67.2246L232.032 67.3033",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.467 67.3472C215.375 69.2529 218.776 70.2682 222.254 70.2684",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.408 44.6065C237.372 42.4454 235.915 40.5127 234.123 38.9214",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.032 67.3472C229.127 69.2527 225.728 70.268 222.254 70.2684",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.163 67.2246C234.343 65.7699 236.179 63.8564 237.542 61.6182",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.542 61.6182C238.623 59.8696 239.389 57.9457 239.808 55.9331",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.467 67.3468C210.231 65.8841 208.348 63.9421 206.956 61.6616",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.376 38.8774C213.648 35.9679 217.875 34.3618 222.254 34.3643",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.122 38.8774C230.853 35.9699 226.629 34.364 222.254 34.3643",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.808 55.9766C240.057 54.7799 240.183 53.5607 240.184 52.3381C240.18 51.654 240.136 50.9706 240.053 50.2915",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.408 44.6064C239.273 46.3953 239.829 48.3174 240.053 50.2916",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.665 55.9766C204.418 54.7796 204.295 53.5604 204.297 52.3381C204.298 51.6541 204.339 50.9708 204.42 50.2915",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.376 38.8774C208.584 40.4687 207.127 42.4015 206.09 44.5626",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.09 44.6064C205.23 46.3968 204.674 48.3182 204.446 50.2916",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.665 55.9766C205.087 57.9879 205.853 59.9113 206.93 61.6617",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.254 38.8774H234.122",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.376 38.8774H222.254",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.408 44.5625H206.09",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.052 50.248H204.446",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.163 55.9331H239.808",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.703 55.9331H204.691",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.163 55.9331H212.703",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.542 61.6182H206.956",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.032 67.3032H232.163",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.254 67.3032H232.032",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.703 67.3032H212.467",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.254 67.3032H212.703",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.254 38.8774V34.3643",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.163 39.3149V44.5628",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.703 39.3149V44.5628",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.254 44.7812V50.1865",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.163 55.933V50.7114",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.703 50.7114V55.933",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.254 56.1514V61.5566",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.254 67.3032V70.2245",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.163 67.2244V62.0815",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.163 67.2246V67.3033",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.703 62.0815V67.3031",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.175 70.2243C232.077 70.2243 240.105 62.1968 240.105 52.2943C240.105 42.3918 232.077 34.3643 222.175 34.3643C212.272 34.3643 204.245 42.3918 204.245 52.2943C204.245 62.1968 212.272 70.2243 222.175 70.2243Z",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.787 50.7288C243.962 53.4927 239.082 54.6734 235.277 52.8104C232.277 51.341 229.863 48.8658 230.388 45.2273C230.913 41.5889 234.166 39.5685 235.531 36.2798C236.991 32.7813 237.087 27.2886 237.087 27.2886C237.087 27.2886 239.615 30.1574 239.904 31.9067C240.084 32.9676 240.183 34.0406 240.201 35.1166L242.099 30.0524C242.519 31.8017 242.851 33.6384 243.394 35.3615C244.356 38.379 247.076 39.9008 248.44 42.5422C249.805 45.1836 248.886 48.6297 246.787 50.7288Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.65 52.4255C239.65 52.4255 236.79 50.3089 237.341 47.3613C237.892 44.4138 239.738 43.8628 239.738 43.8628C240.354 44.4173 240.84 45.1022 241.159 45.8677C241.478 46.6331 241.623 47.46 241.583 48.2884C241.511 49.8688 240.816 51.3563 239.65 52.4255V52.4255Z",
    fill: "#1AE5B2",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9535 169.496C64.8559 169.496 72.8835 161.468 72.8835 151.566C72.8835 141.663 64.8559 133.636 54.9535 133.636C45.051 133.636 37.0234 141.663 37.0234 151.566C37.0234 161.468 45.051 169.496 54.9535 169.496Z",
    fill: "#1AE5B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9534 169.496C62.6 169.496 68.7989 161.468 68.7989 151.566C68.7989 141.663 62.6 133.636 54.9534 133.636C47.3067 133.636 41.1079 141.663 41.1079 151.566C41.1079 161.468 47.3067 169.496 54.9534 169.496Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9533 169.496C58.5762 169.496 61.5131 161.468 61.5131 151.566C61.5131 141.663 58.5762 133.636 54.9533 133.636C51.3305 133.636 48.3936 141.663 48.3936 151.566C48.3936 161.468 51.3305 169.496 54.9533 169.496Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6123 136.259H64.0059",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9504 145.391H71.6764",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0234 154.522H72.5949",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7056 163.662H68.9126",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9535 169.496C64.8559 169.496 72.8835 161.468 72.8835 151.566C72.8835 141.663 64.8559 133.636 54.9535 133.636C45.051 133.636 37.0234 141.663 37.0234 151.566C37.0234 161.468 45.051 169.496 54.9535 169.496Z",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0232 148.863C65.3422 148.865 63.7306 149.534 62.5419 150.723C61.3533 151.911 60.6844 153.523 60.6821 155.204V169.679H73.3643V155.248C73.369 154.412 73.2084 153.583 72.8919 152.809C72.5754 152.035 72.1092 151.331 71.52 150.738C70.9308 150.145 70.2303 149.674 69.4586 149.352C68.687 149.03 67.8593 148.864 67.0232 148.863ZM62.4314 156.953V155.204C62.4314 153.986 62.9152 152.818 63.7763 151.957C64.6375 151.096 65.8054 150.612 67.0232 150.612C68.2411 150.612 69.409 151.096 70.2702 151.957C71.1313 152.818 71.6151 153.986 71.6151 155.204V156.953H62.4314Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7289 161.808C68.7257 161.494 68.6384 161.187 68.4761 160.919C68.3137 160.651 68.0824 160.432 67.8061 160.284C67.5299 160.136 67.219 160.065 66.9059 160.078C66.5928 160.091 66.289 160.188 66.0262 160.359C65.7635 160.53 65.5515 160.768 65.4123 161.049C65.2732 161.33 65.212 161.643 65.2353 161.955C65.2585 162.268 65.3653 162.568 65.5445 162.825C65.7236 163.083 65.9686 163.287 66.2537 163.417L65.7901 167.257H68.1429L67.6794 163.417C67.9923 163.28 68.2584 163.055 68.4449 162.769C68.6314 162.483 68.7301 162.149 68.7289 161.808Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.437 169.496C274.34 169.496 282.367 161.468 282.367 151.566C282.367 141.663 274.34 133.636 264.437 133.636C254.535 133.636 246.507 141.663 246.507 151.566C246.507 161.468 254.535 169.496 264.437 169.496Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.16 147.341H250.775V138.691H269.283L272.16 147.341Z",
    fill: "#1AE5B2",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.169 143.738H250.775V162.481H278.169V143.738Z",
    fill: "#1AE5B2",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.125 149.3C273.444 149.303 271.833 149.971 270.644 151.16C269.455 152.349 268.786 153.96 268.784 155.641V170.073H281.466V155.685C281.471 154.849 281.31 154.02 280.994 153.246C280.677 152.473 280.211 151.769 279.622 151.176C279.033 150.582 278.332 150.111 277.561 149.789C276.789 149.468 275.961 149.301 275.125 149.3V149.3ZM270.533 157.434V155.685C270.533 154.467 271.017 153.299 271.878 152.438C272.74 151.577 273.907 151.093 275.125 151.093C276.343 151.093 277.511 151.577 278.372 152.438C279.233 153.299 279.717 154.467 279.717 155.685V157.434H270.533Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.831 162.219C276.829 161.905 276.742 161.597 276.579 161.329C276.417 161.06 276.185 160.84 275.909 160.691C275.632 160.543 275.321 160.472 275.007 160.485C274.693 160.498 274.389 160.596 274.126 160.768C273.863 160.939 273.651 161.178 273.512 161.46C273.374 161.742 273.313 162.056 273.338 162.369C273.362 162.682 273.47 162.982 273.651 163.239C273.832 163.496 274.078 163.699 274.365 163.828L273.901 167.668H276.245L275.781 163.828C276.094 163.692 276.36 163.466 276.547 163.18C276.733 162.894 276.832 162.56 276.831 162.219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.898 148.067C151.898 148.067 121.574 164.099 120.988 165.848C120.402 167.598 125.361 200.545 127.111 212.204C128.307 221.014 128.99 229.886 129.157 238.776V243.735H209.624C209.624 243.735 215.449 158.309 213.411 157.434C211.373 156.56 175.802 144.901 175.802 144.901L151.898 148.067Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.56 184.286C183.56 184.286 180.332 183.875 175.951 179.362V179.3V179.362C171.577 183.875 168.341 184.286 168.341 184.286C167.187 193.741 175.172 196.985 175.951 197.274C176.72 196.985 184.714 193.741 183.56 184.286Z",
    fill: "#1AE5B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.933 198.166C175.878 198.175 175.822 198.175 175.767 198.166C175.663 198.152 175.562 198.12 175.469 198.07C172.751 197.016 170.471 195.069 169.006 192.548C167.54 190.027 166.976 187.082 167.405 184.198C167.429 184.005 167.517 183.825 167.655 183.687C167.793 183.549 167.973 183.461 168.166 183.437C168.166 183.437 171.149 182.965 175.163 178.854C175.232 178.741 175.325 178.644 175.435 178.57C175.546 178.496 175.671 178.447 175.802 178.426C175.955 178.399 176.113 178.417 176.257 178.478C176.443 178.554 176.6 178.689 176.703 178.863C180.7 182.921 183.638 183.394 183.7 183.394C183.89 183.421 184.066 183.51 184.2 183.648C184.335 183.786 184.42 183.964 184.443 184.155C184.872 187.034 184.311 189.974 182.85 192.493C181.39 195.011 179.117 196.959 176.405 198.018C176.264 198.109 176.101 198.16 175.933 198.166V198.166ZM169.085 184.994C168.843 187.373 169.378 189.766 170.609 191.815C171.84 193.865 173.702 195.461 175.915 196.364C178.129 195.46 179.991 193.864 181.223 191.815C182.456 189.766 182.993 187.373 182.755 184.994C181.583 184.653 179.047 183.604 175.915 180.569C172.784 183.604 170.257 184.653 169.085 184.994Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.936 165.481C153.936 165.481 153.358 193.837 153.936 208.417C154.513 222.997 156.271 243.691 156.271 243.691",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.56 176.921C157.202 176.921 157.723 176.4 157.723 175.758C157.723 175.116 157.202 174.595 156.56 174.595C155.917 174.595 155.396 175.116 155.396 175.758C155.396 176.4 155.917 176.921 156.56 176.921Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.56 204.035C157.202 204.035 157.723 203.514 157.723 202.872C157.723 202.229 157.202 201.708 156.56 201.708C155.917 201.708 155.396 202.229 155.396 202.872C155.396 203.514 155.917 204.035 156.56 204.035Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.184 224.16C159.184 224.392 159.115 224.619 158.985 224.812C158.856 225.005 158.673 225.155 158.458 225.244C158.243 225.332 158.007 225.355 157.78 225.309C157.552 225.263 157.343 225.151 157.18 224.986C157.016 224.821 156.905 224.611 156.861 224.384C156.817 224.156 156.841 223.92 156.931 223.706C157.021 223.492 157.173 223.309 157.367 223.182C157.561 223.054 157.788 222.987 158.02 222.988C158.33 222.991 158.626 223.115 158.843 223.335C159.061 223.554 159.184 223.851 159.184 224.16Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.382 232.032L181.338 236.694C181.338 236.694 169.968 229.408 166.181 229.111C162.394 228.814 157.723 229.408 155.099 231.735C152.475 234.061 151.023 235.819 148.102 235.819C145.181 235.819 141.691 236.108 143.44 238.443C145.189 240.779 151.312 240.779 153.647 239.904C155.982 239.029 159.472 238.155 159.472 238.155C160.697 239.833 162.44 241.062 164.431 241.653C166.527 242.195 168.679 242.488 170.842 242.528C170.842 242.528 176.388 246.026 179.886 245.729C181.989 245.556 184.053 245.067 186.009 244.277L196.793 241.067C196.793 241.067 193.88 234.07 190.382 232.032Z",
    fill: "#ABABAB",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.557 226.784C163.557 226.784 160.058 224.737 158.309 226.784C156.56 228.831 155.974 239.318 156.848 240.481C157.723 241.644 158.309 239.029 159.472 238.154C160.636 237.28 163.557 226.784 163.557 226.784Z",
    fill: "#ABABAB",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.679 227.947C169.679 227.947 165.306 225.324 163.557 226.784C161.808 228.245 158.598 239.904 159.472 241.067C160.347 242.23 162.971 241.067 163.268 239.606C163.566 238.146 168.516 230.571 168.516 230.571L169.679 227.947Z",
    fill: "#ABABAB",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.676 232.653C176.676 232.653 171.14 227.405 169.679 227.991C168.219 228.577 160.058 240.822 162.096 242.274C164.134 243.726 171.14 234.989 171.14 234.989L173.764 237.026",
    fill: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.676 232.653C176.676 232.653 171.14 227.405 169.679 227.991C168.219 228.577 160.058 240.822 162.096 242.274C164.134 243.726 171.14 234.989 171.14 234.989L173.764 237.026",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.259 239.318C184.259 239.318 179.012 230.86 177.262 230.86C175.513 230.86 165.595 239.904 165.595 239.904C165.595 239.904 168.516 242.231 169.391 241.653C170.265 241.076 175.216 237.857 175.216 237.857C175.216 237.857 176.09 242.528 179.3 243.403",
    fill: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.259 239.318C184.259 239.318 179.012 230.86 177.262 230.86C175.513 230.86 165.595 239.904 165.595 239.904C165.595 239.904 168.516 242.231 169.391 241.653C170.265 241.076 175.216 237.857 175.216 237.857C175.216 237.857 176.09 242.528 179.3 243.403",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.749 156.56C208.749 156.56 215.449 156.56 216.035 159.481C216.621 162.403 217.198 168.805 217.198 168.805C217.198 168.805 242.86 228.866 241.985 231.49C241.111 234.114 202.041 246.945 200.877 246.945C199.714 246.945 190.382 232.076 190.382 232.076L209.326 220.12L199.417 193.548",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.749 156.56C208.749 156.56 215.449 156.56 216.035 159.481C216.621 162.403 217.198 168.805 217.198 168.805C217.198 168.805 242.86 228.866 241.985 231.49C241.111 234.114 202.041 246.945 200.877 246.945C199.714 246.945 190.382 232.076 190.382 232.076L209.326 220.12L199.417 193.548",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.953 175.181C204.953 175.181 196.504 182.466 195.918 191.799",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.956 174.927C197.956 174.927 193.294 182.178 193.294 190.924",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.326 220.076C209.326 220.076 214.872 215.117 217.198 215.117C219.525 215.117 224.781 216.289 225.944 221.239",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.123 214.54C213.123 214.54 220.994 209.869 223.618 211.916C225.374 213.433 226.767 215.325 227.694 217.452",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.988 165.849L112.242 221.825C112.242 221.825 102.621 228.822 106.119 239.318C107.501 243.464 111.367 245.44 129.157 243.691C130.058 233.118 130.058 222.488 129.157 211.916C127.697 193.295 120.988 165.849 120.988 165.849Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.95 229.347C118.95 229.347 124.942 229.487 125.362 230.178C125.781 230.869 125.781 240.21 124.391 241.19C123 242.169 122.02 242.58 121.461 241.19C120.901 239.799 119.93 236.869 119.93 236.869C119.93 236.869 116.169 241.05 112.539 240.21C108.91 239.37 108.499 237.709 107.388 237.289C106.277 236.869 104.764 237.429 102.227 236.414C99.691 235.4 96.9359 231.682 96.9359 231.682C96.9359 231.682 90.2449 237.534 88.8542 236.834C87.4636 236.134 88.9942 233.913 91.2245 231.542C93.4548 229.172 94.9854 226.802 97.2158 226.242C99.4461 225.682 108.359 224.572 111.149 225.411C113.939 226.251 116.309 227.502 116.58 227.913C117.309 228.486 118.105 228.967 118.95 229.347V229.347Z",
    fill: "#ABABAB",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.714 224.467C100.714 224.467 96.9533 223.767 96.5334 226.277C96.1136 228.787 97.0932 238.522 98.0641 239.397C98.3743 239.601 98.7273 239.731 99.0958 239.776C99.4643 239.822 99.8384 239.783 100.189 239.661C100.54 239.539 100.858 239.339 101.119 239.074C101.38 238.81 101.577 238.489 101.694 238.137C102.245 236.467 102.105 227.694 102.105 227.694C102.105 227.694 102.525 225.306 100.714 224.467Z",
    fill: "#ABABAB",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.685 225.997C107.685 225.997 102.105 222.499 100.688 224.467C99.2712 226.435 100.828 238.26 101.563 239.799C102.297 241.338 104.904 241.89 105.464 240.21C106.023 238.531 106.155 231.578 106.338 231.158",
    fill: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.685 225.997C107.685 225.997 102.105 222.499 100.688 224.467C99.2712 226.435 100.828 238.26 101.563 239.799C102.297 241.338 104.904 241.89 105.464 240.21C106.023 238.531 106.155 231.578 106.338 231.158",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.886 227.948C110.746 228.367 110.886 240.63 109.216 241.469C107.545 242.309 105.175 242.3 105.175 236.729C105.175 231.158 105.455 224.327 106.986 223.767C108.516 223.207 112.837 225.586 114.376 226.977",
    fill: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.886 227.948C110.746 228.367 110.886 240.63 109.216 241.469C107.545 242.309 105.175 242.3 105.175 236.729C105.175 231.158 105.455 224.327 106.986 223.767C108.516 223.207 112.837 225.586 114.376 226.977",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.947 236.869L118.688 231.297",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.254 147.971V163.863L152.318 158.099L144.254 147.971Z",
    fill: "#BABABA",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.927 165.472L144.254 147.971L153.7 141.28L153.927 165.472Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.927 137.37C150.927 137.37 152.773 153.262 153.236 157.872C153.7 162.481 153.927 165.481 153.927 165.481C153.927 165.481 168.21 148.863 170.974 145.198C173.738 141.534 174.429 140.362 174.429 140.362L175.128 123.315L150.927 137.37Z",
    fill: "#ABABAB",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.312 140.703C152.698 141.757 154.321 142.456 156.039 142.74C157.757 143.023 159.518 142.883 161.169 142.33C167.292 140.082 169.041 136.207 170.379 134.869C171.254 133.994 173.091 132.787 174.796 131.37L175.128 123.315L150.927 137.37C150.927 137.37 151.085 138.7 151.312 140.703Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.382 150.735L153.927 165.472L165.219 158.099L160.382 150.735Z",
    fill: "#BABABA",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.382 150.735L165.673 165.017L181.347 144.743L176.738 135.297L160.382 150.735Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.061 76.8631C139.519 80.2107 136.272 85.0242 134.869 90.4899C132.744 99.4024 137.239 109.085 137.572 112.067C137.904 115.05 136.627 118.924 138.035 122.607C139.443 126.289 145.671 132.123 146.668 134.851C147.665 137.58 153.245 142.496 159.315 140.274C165.385 138.053 167.292 134.152 168.674 132.805C170.056 131.458 173.921 129.201 175.793 126.682C177.665 124.163 178.846 122.362 178.846 122.362C178.846 122.362 183.761 110.283 184.181 99.5161C184.601 88.7494 178.216 76.5395 166.155 73.1809C154.093 69.8223 144.061 76.8631 144.061 76.8631Z",
    fill: "#ABABAB",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M134.265 105.831C134.265 105.831 134.432 112.933 137.012 114.796C139.592 116.659 145.155 116.546 147.402 115.61C149.65 114.674 150.953 109.933 151.898 108.569C152.843 107.204 155.913 107.93 155.913 107.93C155.913 107.93 158.108 114.14 159.848 114.849C161.589 115.557 167.09 116.773 170.939 114.761C174.787 112.75 175.539 104.957 175.539 104.957C175.539 104.957 177.778 104.528 177.157 103.373C176.537 102.219 159.464 102.236 157.443 102.901C155.423 103.566 155.16 104.476 154.058 104.458C152.956 104.441 151.434 103.286 150.332 103.269C149.23 103.251 133.916 103.522 133.916 103.522L134.265 105.831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.181 73.242C154.119 69.8834 144.087 76.863 144.087 76.863C140.363 79.628 137.485 83.3782 135.778 87.691C136.259 86.554 138.236 82.3557 141.901 81.4199C146.16 80.3266 146.221 84.2187 151.6 82.9067C156.979 81.5948 165.341 77.3528 169.032 79.4607C172.723 81.5685 175.644 85.9592 174.14 90.5248C172.635 95.0904 172.487 98.519 174 99.6822C175.513 100.846 177.35 104.536 177.498 106.828C177.612 108.717 180.122 110.003 182.79 109.662C183.563 106.349 184.04 102.974 184.216 99.5773C184.609 88.8193 178.216 76.6006 166.181 73.242Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.461 117.009C148.461 117.009 147.044 119.055 148.338 119.991C148.648 120.315 149.062 120.518 149.507 120.564C149.953 120.611 150.4 120.498 150.77 120.245",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.93 119.09C150.919 119.956 152.131 120.526 153.428 120.735C155.414 120.988 157.487 118.985 157.487 118.985",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.77 119.825C156.77 119.825 157.4 120.752 159.219 119.633C159.219 119.633 161.685 118.968 160.242 116.204",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.592 124.802C148.592 124.802 155.361 127.426 161.283 123.586",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.956 109.085C164.912 110.283 164.326 111.254 163.653 111.245C162.98 111.236 162.472 110.248 162.525 109.05C162.577 107.851 163.154 106.88 163.828 106.889C164.501 106.898 165.009 107.878 164.956 109.085Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.656 109.207C147.656 110.414 147.026 111.376 146.353 111.368C145.679 111.359 145.172 110.379 145.224 109.181C145.277 107.983 145.854 107.012 146.528 107.021C147.201 107.029 147.708 108.009 147.656 109.207Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.265 105.831C134.265 105.831 134.432 112.933 137.012 114.796C139.592 116.659 145.155 116.546 147.402 115.61C149.65 114.674 150.953 109.933 151.898 108.569C152.843 107.204 155.913 107.93 155.913 107.93C155.913 107.93 158.108 114.14 159.848 114.849C161.589 115.557 167.09 116.773 170.939 114.761C174.787 112.75 175.539 104.957 175.539 104.957C175.539 104.957 177.778 104.528 177.157 103.373C176.537 102.219 159.464 102.236 157.443 102.901C155.423 103.566 155.16 104.476 154.058 104.458C152.956 104.441 151.434 103.286 150.332 103.269C149.23 103.251 133.916 103.522 133.916 103.522L134.265 105.831Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.157 103.391L184.338 106.915L183.848 108.052L175.539 104.974L177.157 103.391Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.434 102.918C155.414 103.574 155.152 104.493 154.05 104.475C152.948 104.458 151.426 103.303 150.324 103.286C149.222 103.268 133.907 103.539 133.907 103.539L134.117 104.904L150.166 104.659C150.166 104.659 152.51 104.466 152.204 106.286C151.767 108.822 151.889 108.577 151.889 108.577C152.825 107.213 155.904 107.939 155.904 107.939L156.122 108.525C155.974 107.37 155.851 105.568 156.464 104.965C157.391 104.09 161.589 104.344 165.367 104.16C168.771 104.17 172.169 104.442 175.531 104.974L177.07 103.312C175.706 102.236 159.411 102.271 157.434 102.918Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.551 111.184C177.551 111.184 182.939 103.916 185.536 105.551C188.134 107.187 186.061 114.726 184.373 118.146C182.685 121.566 178.662 122.423 177.883 119.668",
    fill: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.551 111.184C177.551 111.184 182.939 103.916 185.536 105.551C188.134 107.187 186.061 114.726 184.373 118.146C182.685 121.566 178.662 122.423 177.883 119.668",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.192 243.402H76.5569L68.0554 196.46H135.691L144.192 243.402Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.568 243.402H73.9329L65.4314 196.46H133.067L141.568 243.402Z",
    fill: "#1AE5B2",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5569 243.402H141.569L135.306 208.828L76.5569 243.402Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.271 243.402H73.9329V246.245H180.271V243.402Z",
    fill: "#1AE5B2",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.271 243.402H142.478V246.245H180.271V243.402Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3375_12697"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 317.493,
    height: 300,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutorizationSuccess);
export default __webpack_public_path__ + "static/media/autorization-success.8351ca83ca3d4cc714c0aac5d7c3e648.svg";
export { ForwardRef as ReactComponent };